import { css } from '@emotion/css';
import { theme, sizes } from 'Shared/frontend/SettingsProvider';
import { amount } from 'Shared/frontend/widgets/Amount';
import { Component } from 'Shared/frontend/widgets/Component';
import { lookupRatio } from 'Shared/frontend/widgets/HeightUtils';
import { ChildKeyContext } from 'Shared/frontend/widgets/StylesProvider';
import { Match, Switch, For } from 'solid-js';

function rowHeight(height)
{
	if (height.child)
		return 'auto';
	if (height.height) 
		return amount(height.height);
	/* The ratio heights are dealt with later */
	return 'none';
}

export function Grid(P)
{
	const gridStyle = () => {
		const numRows = () => Math.ceil((P.items?.length ?? 0) / P.itemsPerRow);

		return {
			width: '100%',
			display: 'grid',
			gridTemplateColumns: '1fr '.repeat(P.itemsPerRow),
			gridTemplateRows: (rowHeight(P.cellHeight)+' ').repeat(numRows()),

			/* 
				We may want 'center' or something as a option for text. 
				Possibly best dealt with using themes/classes/decorators. 
			*/
			alignItems: 'stretch',

			/* Think this is just for edge cases - eg very narrow child images that aren't being stretched */
			justifyItems: 'center',

			...theme().widgets.grid,
		};
	}

	const foldStyle = () => ({
		[`@container (max-width:${sizes().flipToOneColumn}px)`]: {
			gridTemplateColumns: '1fr',
			gridTemplateRows: (rowHeight(P.cellHeight)+' ').repeat(P.items?.length ?? 0) 
		},
	});

//TODO default gap may be best to be eg 1cqw

	return (
		<div class={css(
			gridStyle(),
			P.fold ? foldStyle() : {},
			P.styling.css ?? {}
		)}>
			<For each={P.items}>{(item,index) =>
				<ChildKeyContext.Provider value={index}>
					<Switch>
						<Match when={P.cellHeight.ratio}>
							{/* width:100% is required for narrow images */}
							<div style={{'aspect-ratio':lookupRatio(P.cellHeight),width:'100%'}}>
								<Component {...item} />
							</div>
						</Match>
						<Match when={true}>
							<Component {...item} />
						</Match>
					</Switch>
				</ChildKeyContext.Provider>
			}</For>
		</div>
	);
}

